"use client";
import React from "react";
import {
  SnackbarProvider as NotistackSnackbarProvider,
  SnackbarProviderProps,
} from "notistack";

import { renderCloseIconButton } from "./CloseIconButton";

import "./styles.css";

export const SnackbarProvider = ({
  children,
  ...props
}: SnackbarProviderProps) => (
  <NotistackSnackbarProvider
    hideIconVariant
    preventDuplicate
    action={renderCloseIconButton}
    className="bg-white! dark:bg-blue-oxford! text-text! dark:text-white! pl-8!"
    {...props}
  >
    {children}
  </NotistackSnackbarProvider>
);
